import axios from 'axios'
import { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success, getNewToken } from '../../shared/constants'

export const useTarget = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [target, setTarget] = useState(false)
  const { addNewTarget, editNewTarget, deleteNewTarget, getNewTarget } = useContext(ConfigurationContext)
  const [loading, setLoading] = useState(false)
  const [cancelToken, setCancelToken] = useState()
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pdfCsvData, setPdfCsvData] = useState({ headings: [], headingValues: [] })
  const [paginate, setPaginate] = useState({})

  useEffect(() => {
    if (cancelToken) {
      setLoading(true)
    }
  }, [cancelToken])

  const getAllTarget = async (dto = {}) => {
    axios
      .get(API.GET_ALL_TARGET(urlSearchParams(dto)), {
        ...header,
        cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        getNewTarget(data.data ? data.data : [])
        setPaginate(data.paginate)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const addTarget = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_TARGET, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Target  Added Successfully', success)
        // addNewTarget(data.data)
        history.push(ROUTES.ALL_TARGETS)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }
  const updateTarget = (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_TARGET, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Target  Update Successfully', success)
        // addNewTarget(data.data)
        history.push(ROUTES.ALL_TARGETS)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getTarget = (dto) => {
    setLoading(true)
    axios
      .post(API.GET_TARGET, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        // toastMessage('Target  Added Successfully', success)
        // addNewTarget(data.data)
        setTarget(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteTarget = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_TARGET, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Target Deleted Successfully', success)
        // addNewTarget(data.data)
        deleteNewTarget(dto.targetId)
        setSelected([])
        // history.push(ROUTES.ALL_TARGETS)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteManyTarget = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_MANY_TARGET, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        // toastMessage('Multiple Target Deleted Successfully', success)
        toastMessage(`${dto.targetId.length} Target Deleted Successfully`, success)

        dto.targetId.map((item) => deleteNewTarget(item))
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        window.location.reload()
        bulkUploadPopup(data, addNewTarget)
        return getAllTarget()
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getPdfCsvData = async (dto = {}) => {
    setDownloadLoading(true)
    dto = { ...dto, download: 1 }
    axios
      .get(API.GET_ALL_TARGET(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setDownloadLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPdfCsvData(data)
      })
      .catch((err) => {
        setDownloadLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  return {
    addTarget,
    getAllTarget,
    deleteTarget,
    getTarget,
    target,
    updateTarget,
    deleteManyTarget,
    BulkUpload,
    pdfCsvData,
    downloadLoading,
    getPdfCsvData,
    paginate,
    loading,
  }
}
